import {AutoDispatchTimeRange} from "./visit-schedule-dispatch-settings.model";

export function buildAutoDispatchTimeRanges(): AutoDispatchTimeRange[] {
  const ranges: AutoDispatchTimeRange[] = [];
  for (let h = 0; h <= 22; h++) {
    ranges.push({
      from: h.toString().padStart(2, '0') + ':00',
      to: ((h + 2) % 24).toString().padStart(2, '0') + ':00',
    });
  }
  return ranges;
}

export function findAutoDispatchTimeRange(
  ranges: AutoDispatchTimeRange[],
  from: string,
  to: string
): AutoDispatchTimeRange {
  return ranges.find(r => r.from === from && r.to === to) || ranges[0];
}
